import { useTranslations } from "@/i18n/LocaleProvider";

export default function ConfirmedStep({ bookingReference }: { bookingReference: string }) {
  const { t } = useTranslations();
  return (
    <div className="mt-8 space-y-4">
      <p>
        {t("book.confirmed.noticeBefore")} <strong>{bookingReference}</strong>{" "}
        {t("book.confirmed.noticeAfter")}
      </p>
    </div>
  );
}
